export default {
  auth: {
    // Shared
    email: "Email",
    password: "Password",
    copyright: "© 2026 · Haltrix Partners",
    backToLogin: "← Back to login",
    resetTitle: "Reset password",
    unknownError: "Unknown error",
    pwdMismatch: "Passwords don't match",

    // Login
    taglineLine1: "Intelligent monitoring",
    taglineLine2: "of the pharmaceutical market",
    subtitle: "Sign in with your corporate credentials",
    emailPlaceholder: "user@helixscan.es",
    showPassword: "Show password",
    hidePassword: "Hide password",
    forgotPassword: "Forgot your password?",
    verifying: "Verifying…",
    signIn: "Sign in",
    wrongCredentials: "Incorrect credentials",
    wrong2faCode: "Incorrect verification code",
    twoFactorTitle: "Two-step verification",
    twoFactorDesc: "Enter the 6-digit code from your authenticator app (or a backup code).",
    verify: "Verify",
    back: "← Back",
    enrollTitle: "Set up two-step verification",
    enrollDesc: "Your organization requires 2FA. Set it up once to continue.",

    // Forgot password
    forgotDesc: "Enter your email and we'll send you a link to choose a new password.",
    forgotEmailPlaceholder: "you@company.com",
    forgotError: "We couldn't process your request. Please try again.",
    sending: "Sending…",
    sendLink: "Send link",
    checkEmail: "Check your email",
    sentTextPre: "If",
    sentTextPost: "is registered, you'll receive a link to reset your password in the next few minutes.",
    linkExpires: "The link expires in 15 minutes. Check your spam folder too.",

    // Reset password
    pwdTooShort: "The password must be at least 8 characters",
    linkInvalidExpired: "The link is invalid or has expired",
    linkInvalid: "Invalid or incomplete link.",
    backToLoginPlain: "Back to login",
    greeting: "Hi, {name} 👋",
    resetDesc: "Choose a secure password of at least 8 characters.",
    newPassword: "New password",
    newPasswordPlaceholder: "At least 8 characters",
    confirmPassword: "Confirm password",
    confirmPasswordPlaceholder: "Repeat the password",
    pwdUpdatedTitle: "Password updated",
    pwdUpdatedText1: "Your password has been changed successfully.",
    pwdUpdatedText2: "Redirecting to login in a few seconds…",
    goToLoginNow: "Go to login now",
    saving: "Saving…",
    saveNewPassword: "Save new password",
  },
};
